// Entry of the "public" webpack bundle: the CEO's public pages + our legal/contact pages on his layout.
import '../../css/public/public.css';
import { Application } from '@hotwired/stimulus';
import PublicContactController from './controllers/public_contact_controller.js';
import ContactFormController from '../controllers/contact_form_controller.js';

const application = Application.start();
application.register('public-contact', PublicContactController);
// /kontakt/ page form (shared with the client bundle's controller file)
application.register('contact-form', ContactFormController);

export { application };
